(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/swipe-arrows/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/sport/swipe-arrows/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.sport = svs.sport || {};
svs.sport.swipeArrows = svs.sport.swipeArrows || {};

 })(window);